<ion-app>
  @if (isAuthenticationPage) {
    <ion-router-outlet></ion-router-outlet>
  } @else {
    <div class="application-background">
    <ion-split-pane contentId="main-content" when="lg" class="application-shell">
      <ion-menu contentId="main-content" type="overlay" class="app-sidebar">
        <ion-content class="ion-no-padding">
          <aside class="flex min-h-full flex-col bg-white">
            <div class="flex h-24 items-center gap-3 border-b border-slate-100 px-7">
              <span class="flex h-11 w-11 items-center justify-center rounded-2xl bg-indigo-600 text-white shadow-lg shadow-indigo-200">
                <ion-icon name="checkmark-done-outline" class="text-2xl"></ion-icon>
              </span>
              <div>
                <p class="m-0 text-lg font-black tracking-tight text-slate-900">{{ activeProfile.shortName }}</p>
                <p class="m-0 text-[11px] font-semibold uppercase tracking-[0.18em] text-indigo-400">
                  Workspace
                </p>
              </div>
            </div>

            <nav class="flex-1 overflow-y-auto px-4 py-6" aria-label="Điều hướng chính">
              <p class="mb-3 px-3 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">
                Tổng quan
              </p>

              @for (feature of overviewFeatures; track feature.id) {
                <ion-menu-toggle auto-hide="false">
                  <a [routerLink]="feature.route" routerLinkActive="nav-item-active" class="nav-item">
                    <ion-icon [name]="feature.icon"></ion-icon>
                    <span>{{ feature.title }}</span>
                  </a>
                </ion-menu-toggle>
              }

              <div class="mt-7">
                <p class="mb-3 px-3 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">
                  Nghiệp vụ
                </p>

                @for (feature of businessFeatures; track feature.id) {
                  <ion-menu-toggle auto-hide="false">
                    <a [routerLink]="feature.route" routerLinkActive="nav-item-active" class="nav-item mt-2">
                      <ion-icon [name]="feature.icon"></ion-icon>
                      <span>{{ feature.title }}</span>
                    </a>
                  </ion-menu-toggle>
                }
              </div>
            </nav>

            <div class="border-t border-slate-100 p-5">
              <div class="rounded-2xl bg-indigo-50 p-4 text-center">
                <span class="mx-auto flex h-11 w-11 items-center justify-center rounded-2xl bg-white text-indigo-600 shadow-sm">
                  <ion-icon name="rocket-outline" class="text-xl"></ion-icon>
                </span>
                <p class="m-0 mt-3 text-xs font-bold text-slate-800">Quản lý hiệu quả hơn</p>
                <p class="m-0 mt-1 text-[10px] leading-4 text-slate-500">
                  Theo dõi tiến độ công việc tập trung.
                </p>
              </div>
            </div>
          </aside>
        </ion-content>
      </ion-menu>

      <main id="main-content" class="main-panel">
        <header class="topbar">
          <div class="flex items-center gap-3">
            <ion-menu-button class="lg:hidden" aria-label="Mở menu"></ion-menu-button>
            <div>
              <p class="m-0 text-sm font-black text-slate-900 sm:text-base">{{ activeProfile.name }}</p>
              <p class="m-0 mt-0.5 hidden text-[11px] text-slate-400 sm:block">
                {{ activeProfile.baseUrl }}
              </p>
            </div>
          </div>

          <div class="flex items-center gap-3">
            <button type="button" class="topbar-button" aria-label="Thông báo">
              <ion-icon name="notifications-outline"></ion-icon>
              <span class="notification-dot"></span>
            </button>
            <div class="hidden h-8 w-px bg-slate-100 sm:block"></div>
            <div class="flex items-center gap-2">
              <span class="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-indigo-500 to-violet-500 text-xs font-black text-white">
                AD
              </span>
              <div class="hidden sm:block">
                <p class="m-0 text-xs font-bold text-slate-800">Quản trị viên</p>
                <p class="m-0 mt-0.5 text-[10px] text-slate-400">Administrator</p>
              </div>
              <ion-icon name="chevron-down-outline" class="hidden text-sm text-slate-400 sm:block"></ion-icon>
            </div>
          </div>
        </header>

        <section class="route-content">
          <ion-router-outlet></ion-router-outlet>
        </section>
      </main>
    </ion-split-pane>
    </div>
  }
</ion-app>
